export const SHEPHERD_VERSION = 1;

// LockScreen owns z-[9999]; Shepherd must sit below it so session lock always wins.
export const SHEPHERD_Z_INDEX = 9990;

export const TARGET_WAIT_TIMEOUT_MS = 4000;
export const TARGET_POLL_INTERVAL_MS = 150;
export const AUTO_START_SETTLE_MS = 800;

export const CUTOUT_EASING = 'cubic-bezier(.2,.9,.3,1)';
export const CUTOUT_MORPH_MS = 550;
export const CHIP_STAGGER_MS = 250;
